<template>
    <div>
        <nav-bar />
        <div class="main">
            <banner />
            <recipe-browser />
            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import Banner from "../views/recipesPage/Banner";
import RecipeBrowser from "../views/recipesPage/RecipeBrowser";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "RecipesPage",
    components: {
        NavBar,
        Banner,
        RecipeBrowser,
        SiteFooter,
    },
};
</script>
